<!-- 其他资质 公司图片 -->
<template>
    <div class="h100">
        <div class="h100" v-if="imgData.content.style_id == 0">
            <div class="img-div width-height-100 position-relative">
                <img class="width-height-100 of-c" 
                    :style="`
                        border-radius: ${imgData.content.marginData.topRadius}px ${imgData.content.marginData.topRadius}px ${imgData.content.marginData.bottomRadius}px ${imgData.content.marginData.bottomRadius}px;
                    `" :src="imgData.content.imgList[0].picview"
                />
            </div>
        </div>
        <div class="h100 dis-flex" v-if="imgData.content.style_id == 1">
            <div class="img-div w50 h100">
                <img class="width-height-100 of-c" 
                    :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                    :src="imgData.content.imgList[0].picview"/>
            </div>
            <div class="img-div w50 h100">
                <img class="width-height-100 of-c" 
                    :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px ${imgData.content.marginData.bottomRadius}px 0;`" 
                    :src="imgData.content.imgList[1].picview"/>
            </div>
        </div>
        <div class="h100 dis-flex" v-if="imgData.content.style_id == 2">
            <div class="img-div w33 h100">
                <img class="width-height-100 of-c" 
                    :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                    :src="imgData.content.imgList[0].picview"/>
            </div>
            <div class="img-div w33 h100">
                <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[1].picview"/>
            </div>
            <div class="img-div w33 h100">
                <img class="width-height-100 of-c" 
                    :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px ${imgData.content.marginData.bottomRadius}px 0;`" 
                    :src="imgData.content.imgList[2].picview"/>
            </div>
        </div>
        <div class="h100" v-if="imgData.content.style_id == 3">
            <div class="w100 h50 dis-flex">
                <div class="img-div w50 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 0;`" 
                        :src="imgData.content.imgList[0].picview"/>
                </div>
                <div class="img-div w50 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px 0 0;`" 
                        :src="imgData.content.imgList[1].picview"/>
                </div>
            </div>
            <div class="w100 h50 dis-flex">
                <div class="img-div w50 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                        :src="imgData.content.imgList[2].picview"/>
                </div>
                <div class="img-div w50 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 ${imgData.content.marginData.bottomRadius}px 0;`" 
                        :src="imgData.content.imgList[3].picview"/>
                </div>
            </div>
        </div>
        <div class="h100" v-if="imgData.content.style_id == 4">
            <div class="w100 h50 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 0;`" 
                        :src="imgData.content.imgList[0].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[1].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px 0 0;`" 
                        :src="imgData.content.imgList[2].picview"/>
                </div>
            </div>
            <div class="w100 h50 dis-flex">
                <div class="img-div w50 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                        :src="imgData.content.imgList[3].picview"/>
                </div>
                <div class="img-div w50 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 ${imgData.content.marginData.bottomRadius}px 0;`" 
                        :src="imgData.content.imgList[4].picview"/>
                </div>
            </div>
        </div>
        <div class="h100" v-if="imgData.content.style_id == 5">
            <div class="w100 h50 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 0;`" 
                        :src="imgData.content.imgList[0].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[1].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px 0 0;`" 
                        :src="imgData.content.imgList[2].picview"/>
                </div>
            </div>
            <div class="w100 h50 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                        :src="imgData.content.imgList[3].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[4].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 ${imgData.content.marginData.bottomRadius}px 0;`" 
                        :src="imgData.content.imgList[5].picview"/>
                </div>
            </div>
        </div>
        <div class="h100" v-if="imgData.content.style_id == 6">
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 0`" :src="imgData.content.imgList[0].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[1].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px 0 0;`" 
                        :src="imgData.content.imgList[2].picview"/>
                </div>
            </div>
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[3].picview"/>
                </div>
                <div class="img-div w66 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[4].picview"/>
                </div>
            </div>
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                        :src="imgData.content.imgList[5].picview"/>
                </div>
                <div class="img-div w66 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 ${imgData.content.marginData.bottomRadius}px 0;`" 
                        :src="imgData.content.imgList[6].picview"/>
                </div>
            </div>
        </div>
        <div class="h100" v-if="imgData.content.style_id == 7">
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 0;`" 
                        :src="imgData.content.imgList[0].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[1].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px 0 0;`" 
                        :src="imgData.content.imgList[2].picview"/>
                </div>
            </div>
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[3].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[4].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[5].picview"/>
                </div>
            </div>
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                        :src="imgData.content.imgList[6].picview"/>
                </div>
                <div class="img-div w66 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 ${imgData.content.marginData.bottomRadius}px 0;`" 
                        :src="imgData.content.imgList[7].picview"/>
                </div>
            </div>
        </div>
        <div class="h100" v-if="imgData.content.style_id == 8">
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: ${imgData.content.marginData.topRadius}px 0 0 0;`" 
                        :src="imgData.content.imgList[0].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[1].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 ${imgData.content.marginData.topRadius}px 0 0;`" 
                        :src="imgData.content.imgList[2].picview"/>
                </div>
            </div>
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[3].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[4].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[5].picview"/>
                </div>
            </div>
            <div class="w100 h33 dis-flex">
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c"
                        :style="`border-radius: 0 0 0 ${imgData.content.marginData.bottomRadius}px;`" 
                        :src="imgData.content.imgList[6].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c br-0" :src="imgData.content.imgList[7].picview"/>
                </div>
                <div class="img-div w33 h100">
                    <img class="width-height-100 of-c" 
                        :style="`border-radius: 0 0 ${imgData.content.marginData.bottomRadius}px 0;`" 
                        :src="imgData.content.imgList[8].picview"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imgData: {
            type: Object,
            default: {},
        },
        imgList: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
        };
    },
    mounted(){
        if(this.imgList.length){
            this.imgData.content.imgList = this.imgList.map(item => (
                {picview:item}
            ))
        }
    },
    methods: {
    },
};
</script>

<style scoped>
img {
    pointer-events: none;
}
.img-div {
    border: 1px dashed #ccc;
}
.active {
    border: 2px dashed #ff761d;
    box-shadow: 5px 5px 3px 4px rgba(0, 0, 0, 0.4);
}
.width-height-100 {
    width: 100%;
    height: 100%;
}
.w100 {
    width: 100%;
}
.w50 {
    width: 50%;
}
.w40 {
    width: 40%;
}
.w60 {
    width: 60%;
}
.w33 {
    width: 33.3%;
}
.w66 {
    width:66.6%;
}
.w25 {
    width: 25%;
}
.h100 {
    height: 100%;
}
.h50 {
    height: 50%;
}
.h33 {
    height: 33.33%;
}
.position-relative {
    position: relative;
}
.of-c {
    object-fit: cover;
}
.dis-flex {
    display: flex;
}
.br-0 {
    border-radius: 0 0 0 0;
}
</style>